export const appliedFilterLabels = {
  tmsNames: 'TMS',
  shipperNames: 'Shipper',
}
